export default "__VITE_ASSET__DEZ$FRIc__"